
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPitch as ObiPitchElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pitch.js';
 
 
 

 
 export const ObiPitch = createComponent({
   react: React,
   tagName: 'obi-pitch',
   elementClass: ObiPitchElement,
   events: {
     
   }
  });
 
 